export enum QuickActionsEnum {
	ShareButton = 'SHARE',
	WatchButton = 'WATCH',
}
